module.exports = __webpack_public_path__ + "assets/icon-world-component.0f5b4ca7.svg";